const strings = {
  en: {
    label: 'PRICING',
    titlePart1: 'Simple, ',
    titleAccent: 'Transparent',
    titlePart2: ' Pricing',
    subtitle: 'Scale as you grow. No hidden fees.',
    monthly: 'Monthly',
    annual: 'Annual (Save 20%)',
    mostPopular: 'Most Popular',
    addonLabel: 'ADD-ON',
    faqLabel: 'FAQ',
    faqTitle: 'Find the answers that you need.',
    faqImageAlt: 'FAQ Flow',
  },
  zh: {
    label: '价格方案',
    titlePart1: '简单、',
    titleAccent: '透明',
    titlePart2: '的定价',
    subtitle: '按需扩展,绝无隐藏费用。',
    monthly: '按月付费',
    annual: '按年付费(节省 20%)',
    mostPopular: '最受欢迎',
    addonLabel: '增值服务',
    faqLabel: '常见问题',
    faqTitle: '在这里找到您需要的答案。',
    faqImageAlt: '常见问题流程图',
  },
};

export default strings;
